'use client'

import { EoaSigningKeysList } from '~/app/settings/personal/signing-keys/EoaSigningKeysList'
import { SplitsLink } from '~/components/Link'
import { withAuthentication } from '~/components/auth/withAuthentication'
import { PageLayout } from '~/components/component-library'
import { PasskeysEdit } from '~/components/settings/PasskeysEdit'
import { SettingsPageContainer } from '~/components/settings/utils'

const PersonalSigningKeysPageInner = () => {
  return (
    <SettingsPageContainer>
      <PageLayout
        pageType="standard"
        title="Signing keys"
        description={
          <span>
            Manage the passkeys and EOA signers that can sign transactions as
            you.{' '}
            <SplitsLink
              path="https://splits.org/docs/members/keys"
              target="tab"
              underline
            >
              Learn more
            </SplitsLink>
            .
          </span>
        }
      >
        <PasskeysEdit />
        <EoaSigningKeysList />
      </PageLayout>
    </SettingsPageContainer>
  )
}
export const PersonalSigningKeysPage = withAuthentication(
  PersonalSigningKeysPageInner,
)
